import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import AmbTooltip from '../common/AmbTooltip';

const StyledButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isDisabled',
})(({ theme, isDisabled }) => ({
  fontWeight: 600,
  fontSize: 14,
  minWidth: 120,
  height: 30,
  borderRadius: 4,
  textTransform: 'none',
  boxShadow: isDisabled ? 'none' : 'rgba(0, 64, 82, 0.35) 0px 1px 4px 0px',
  backgroundColor: isDisabled
    ? theme?.palette?.primary?.disabled || '#A0A0A0'
    : theme?.palette?.primary?.main || '#1EC0D9',
  color: isDisabled ? 'rgba(0, 0, 0, 0.26)' : '#fff',
  '&:hover': {
    backgroundColor: isDisabled
      ? theme?.palette?.primary?.disabled || '#f5f5f5'
      : theme?.palette?.secondary?.dark || '#00838f',
  },
  '&:disabled': {
    backgroundColor: '#f5f5f5',
    color: 'rgba(0, 0, 0, 0.26)',
  },
}));

const EPCSButton = ({ onClick, disabled, tooltip, ...props }) => {
  const button = (
    <StyledButton
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      isDisabled={disabled}
      data-testid="epcs-button"
      {...props}
    >
      LAUNCH EPCS
    </StyledButton>
  );

  if (disabled && tooltip) {
    return (
      <AmbTooltip title={tooltip} placement="top">
        <span>{button}</span>
      </AmbTooltip>
    );
  }

  return button;
};

EPCSButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
};

EPCSButton.defaultProps = {
  disabled: false,
  tooltip: '',
};

export default EPCSButton;
